import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { ImageTransformOptions, parseFileRefType, convertImageFileRef } from '@core/data';




@Component({
    selector: 'pv-image-ref',
    template: `
        <ng-container [ngSwitch]="status">
            <img [class.hide]="status !== 2" [class.radius]="radius" [class.square-image]="square" [attr.loading]="lazy ? 'lazy' : null" (load)="onLoad($event)" (error)="onError($event)" [src]="src" [alt]="alt">
            <div *ngSwitchCase="1" class="placeholder"></div>
            <div *ngSwitchCase="3" class="errorholder">
                <mat-icon>cloud_off</mat-icon>
            </div>
        </ng-container>
    `,
    styleUrls: ['image-ref.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    host: {
        class: 'pv-image-ref'
    }
})
export class ImageRefComponent implements OnInit, OnDestroy, OnChanges {

    @Input()
    fileRef: string;

    @Input()
    width: number;

    @Input()
    height: number;

    @Input()
    mode: string | 'fill' | 'fit' | 'scale' | 'crop';

    @Input()
    gravity: string | 'center';

    @Input()
    quality: number;

    @Input()
    format: string | 'jpg' | 'png' | 'auto' = 'auto';

    @Input()
    attachment: boolean;

    @Input()
    transformId: string;

    @Input()
    alt: string = '';

    // Emits the loaded image's true natural dimensions — needed by consumers (e.g. the report image
    // component's manual crop/zoom) that must compute against the real image size, not just the
    // rendered box. Purely additive: existing consumers that don't bind to it are unaffected.
    @Output()
    naturalSize = new EventEmitter<{ width: number, height: number }>();

    @Input()
    radius: boolean = false;

    @Input()
    square: boolean = false;

    // opt-in native lazy loading: bytes fetch as the tile nears the viewport, placeholder holds the square until then
    @Input()
    lazy: boolean = false;

    /**
     *
     * Current status
     * 0: uninitialized (or no fileRef)
     * 1: loading
     * 2: ok
     * 3: error
     *
     */
    status: number = 0;
    src: string;

    constructor(private _changeRef: ChangeDetectorRef){}

    ngOnInit(){

    }

    ngOnDestroy(){

    }

    ngOnChanges(changes: SimpleChanges){

        if(!this.fileRef){
            this.status = 0;
            this._changeRef.markForCheck();
            return;
        }

        const type = parseFileRefType(this.fileRef);

        if(type !== 'cloudinary'){
            this.status = 2;
            return;
        }

        const options: ImageTransformOptions = {
            width: this.width,
            height: this.height,
            mode: this.mode,
            gravity: this.gravity,
            quality: this.quality,
            format: this.format,
            attachment: this.attachment,
            transformId: this.transformId,
        };

        this.src = convertImageFileRef(this.fileRef, options);
        this.status = 1;
        this._changeRef.markForCheck();
    }

    onLoad(event: Event){
        this.status = 2;

        const img = event.target as HTMLImageElement;
        if (img?.naturalWidth && img?.naturalHeight) {
            this.naturalSize.emit({ width: img.naturalWidth, height: img.naturalHeight });
        }
    }

    onError(event: Event){
        this.status = 3;
    }

}